module.exports = __webpack_public_path__ + "img/fallback-product.2f516ca0.png";